function click_show_contacts(btn) {
    $(btn).attr('disabled', 'disabled');
    let fd = new FormData();
    fd.set("id_catalog", 4);
    fd.set("id_object", id_product)
    $.ajax({
        type: 'POST',
        url: '/ajax?action=click_show_contacts',
        data: fd,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(result) {
            window.location.href = "/company/"+id_company+"#contacts-company";
        },
        error: function(jqXHR, textStatus) {
            window.location.href = "/company/"+id_company+"#contacts-company";
        }
    });
}


$('#slider-arrow-top').on('click', function () {
    let $next = $(this).next()
    let scrollTop = $next.scrollTop() - 93
    $next.animate({ scrollTop: scrollTop }, 200)
});

$('#slider-arrow-bottom').on('click', function () {
    let $elem = $(this).prev()
    let scrollTop = $elem.scrollTop() + 93
    $elem.animate({ scrollTop: scrollTop }, 200)
});

$('#slider-arrow-right').on('click', function () {
    let $elem = $(this).prev()
    let scrollLeft = $elem.scrollLeft() + 93
    $elem.animate({ scrollLeft: scrollLeft }, 200)
});

$('#slider-arrow-left').on('click', function () {
    let $elem = $(this).next()
    let scrollLeft = $elem.scrollLeft() - 93
    $elem.animate({ scrollLeft: scrollLeft }, 200);
});


let historyPrice = document.getElementById('history-price')



if (historyPrice) {
    // Данные по оси X
    let labels = ["30.06-07.07", "07.07-12.07", "12.07-24.07", "24.07-01.08", "01.08-10.08", "10.08-22.08", "22.08-31.08", "31.08"]

    // Данные по оси Y
    let dataPrices = [31499, 31999, 31999, 32700, 32200, 32200, 31899, 32100]
    window.onload = function() {
        new Chart(historyPrice, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    data: dataPrices,
                    borderWidth: 2,
                    pointRadius: 0,
                    fill: true,
                    borderColor: '#37721e',
                    backgroundColor: function (context) {
                        const chart = context.chart
                        const {ctx, chartArea} = chart
                        if (! chartArea)
                            return
                        return getGradient(ctx, chartArea)
                    },
                    pointHoverRadius: 5,
                    pointBackgroundColor: 'white',

                }]
            },
            options: {
                interaction: {
                    mode: 'index',
                    intersect: false
                },
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    x: {
                        display: false
                    },
                    y: {
                        display: false,
                        min: Math.max(...dataPrices) * 0.9
                    },
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    // Настройка подсказки
                    tooltip: {
                        intersect: false,
                        backgroundColor: 'white',
                        titleColor: '#959595',
                        titleFont: {
                            family: "Montserrat",
                            size: 12,
                            weight: 500
                        },
                        titleAlign: 'center',
                        bodyColor: 'black',
                        bodyFont: {
                            family: "Montserrat",
                            size: 16,
                            weight: 700
                        },
                        callbacks: {
                            label: () => {
                                return ''
                            },
                            afterBody: (context) => {
                                return context[0].parsed.y + " ₽"
                            }
                        },
                        yAlign: 'top'
                    },
                    chartAreaBorder: {
                        borderWidth: 0
                    }
                }
            },

        });
    }

// Получение градиента для графика
    let width, height, gradient;
    function getGradient(ctx, chartArea) {
        const chartWidth = chartArea.right - chartArea.left;
        const chartHeight = chartArea.bottom - chartArea.top;
        if (!gradient || width !== chartWidth || height !== chartHeight) {
            // Create the gradient because this is either the first render
            // or the size of the chart has changed
            width = chartWidth;
            height = chartHeight;
            gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
            gradient.addColorStop(0, 'rgb(23%, 69%, 0%, 0)');
            gradient.addColorStop(1, 'rgb(23%, 69%, 0%, .2)');

        }

        return gradient;
    }
}


$(".slider-photo-product-body").on('scroll', function (event) {
    $(this).closest(".mobile-photo-slider").find('.slider-menu-photo-product').find(`div`).removeClass('active')
    let countPhoto = $(this).find('.photo-product-for-slider').length
    let sizeScroll = $(this).get(0).scrollWidth / countPhoto
    let currentPhoto = Math.floor($(this).scrollLeft() / sizeScroll)
    console.log(currentPhoto)
    console.log($(this).closest(".mobile-photo-slider").find('.slider-menu-photo-product').find(`div:nth-child(${currentPhoto + 1})`).addClass('active'))
    // console.log($(this).get(0).scrollWidth / $(this).scrollLeft())
    // console.log(sizeScroll)
})

$("#slider-arrow-mobile-right").on('click', function () {
    let $prevElement = $(this).prev();
    let countPhoto = $prevElement.find('.photo-product-for-slider').length;
    let sizeScroll = $prevElement.get(0).scrollWidth / countPhoto;

    // Получаем текущую позицию скролла
    let currentScrollLeft = $prevElement.scrollLeft();

    // Вычисляем новую позицию скролла
    let newScrollLeft = currentScrollLeft + sizeScroll;

    // Используем метод animate для плавной анимации скролла
    $prevElement.animate({ scrollLeft: newScrollLeft }, 100);
})

$("#slider-arrow-mobile-left").on('click', function () {
    let $nextElement = $(this).next();
    let countPhoto = $nextElement.find('.photo-product-for-slider').length;
    let sizeScroll = $nextElement.get(0).scrollWidth / countPhoto;

    // Получаем текущую позицию скролла
    let currentScrollLeft = $nextElement.scrollLeft();

    // Вычисляем новую позицию скролла
    let newScrollLeft = currentScrollLeft - sizeScroll;

    // Используем метод animate для плавной анимации скролла
    $nextElement.animate({ scrollLeft: newScrollLeft }, 100);
})


// Массив ссылок на фотографии товара
let arrayPhoto = ["/theme/theme1/assets/img/example-product.webp", "/theme/theme1/assets/img/9859.webp", "/theme/theme1/assets/img/86362.webp"]



// Создаем блоки для пролистывания фотографий и блоки для меню слайдера карточки товара
// $('.photo-card-product').each(function() {
//     for (let i = 0; i < arrayPhoto.length; i++) {
//         let divWithData = $('<div>').attr('data-number-img', i + 1);
//         $(this).find('.wrapper-absolute-photo-card-product').append(divWithData);
//         $(this).parent().parent().find('.slider-menu-photo-product.desktop').append($('<div>'))
//     }
// })
//
// // При наведении на блок для пролистывания фотографии, ставим новую фотографию
// $('div[data-number-img]').on('mouseenter', function (event) {
//     let firstSliderDiv =$(this).parent().parent().parent().next().find('div:first-child');
//
//     (firstSliderDiv.hasClass('active')) ? firstSliderDiv.removeClass('active') : undefined
//
//     $(this).parent().parent().find('.inner-photo-card-product-icon').attr('src', arrayPhoto[$(this).attr('data-number-img') - 1])
//     $(this).parent().parent().parent().next().find(`div:nth-child(${$(this).attr('data-number-img')})`).addClass('active')
// })
//
// $('div[data-number-img]').on('mouseleave', function () {
//     $(this).parent().parent().parent().next().find(`div:nth-child(${$(this).attr('data-number-img')})`).removeClass('active')
// })
//
// // Делаем активным первый элемент слайдера в меню карточки товара
// $('.slider-menu-photo-product.desktop div:first-child').addClass('active')

// Добавление в избарнное
$('.add-favorites').on('click', function (event) {
    event.preventDefault()
    event.stopPropagation()
    $(this).toggleClass('active')
})


// Реализация head товара при скроле страницы
$(window).on('scroll', function () {
    if ($(this).scrollTop() >= 700) {
        $(".wrapper-head-product-sticky").addClass('active')
    }
    else
        $(".wrapper-head-product-sticky").removeClass('active')
})

$(function (){
    $('.basket_product_add').on('click', function (){
        let $btn = $(this);

        if ($btn.data('basket') === true) {
            window.location.href = "https://" + window.location.host + "/cart";
            return;
        }

        $btn.attr('disabled', 'disabled');

        var formData = new FormData();
        formData.set('action', 'basket_product_add');
        formData.set('id_object', id_product);
        formData.set('type_product', 'product');
        $.ajax({
            type: 'POST',
            url: '/ajax',
            data: formData,
            processData: false,
            contentType: false,
            dataType: 'json',
            success: function(result) {
                if (result.response) {
                    $btn.data('basket', true);
                    $('.basket_product_add').text("Товар в корзине");
                } else {
                    alerts('warning', 'Не получилось добавить товар');
                }
            },
            error: function(jqXHR, textStatus) {
                alerts('error', '', 'Не удалось подключиться');
            },
            complete: function(jqXHR, textStatus) {
                $btn.removeAttr('disabled');
            }
        });

    })
})

// console.log($(".small-icon-product[data-icon-product]"))

$(".small-icon-product[data-icon-product]").on("click", function () {
    $(this).closest(".photo-product-row").find(".main-photo-product").attr("src", $(this).attr("src"))
})


